/*
  INSOLITO Shop · Warenkorb-Buttons der ins-* Abschnitte
  Legt Produkte per Shopify Ajax API in den Warenkorb und öffnet danach
  den Warenkorb-Drawer bzw. die Warenkorb-Benachrichtigung von Dawn.
  Ohne JavaScript funktionieren die Formulare trotzdem (Weiterleitung zum Warenkorb).
*/
(() => {
  if (window.__insolitoAtc) return;
  window.__insolitoAtc = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const findCart = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ins-atc]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('.ins-atc__error');
    const cart = findCart();
    const payload = {
      id: Number(form.querySelector('[name="id"]').value),
      quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1)
    };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Das Produkt konnte nicht in den Warenkorb gelegt werden.');
      }
      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = root() + 'cart';
      }
    } catch (err) {
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
